// https://developer.mozilla.org/en-US/docs/Learn/Common_questions/Web_mechanics/What_is_a_domain_name

export const UrlRegex = new RegExp(
  /((https?:\/\/)?([-a-zA-Z0-9%_]{1,63})(\.[-a-zA-Z0-9@:%_\+~=]{1,63})*(\.[a-z]{2,63})([\/?#][-a-zA-Z0-9@:%_\+.~#?&=\/]*)*)/g
)
